export const CSQ_ADDON_DETAILS_CLICK = 'analytics-csq:addon-details-click'
export const CSQ_SUBSCRIPTION_DETAILS_CLICK =
  'analytics-csq:subscription-details-click'
export const CSQ_MEALS_DETAILS_CLICK = 'analytics-csq:meals-details-click'
export const MARKETING_SIGNUP = 'analytics:marketing-signup'
